
import Network from './network';
// 封装各种接口请求
// export const 接口名 = () => Network.get('/路由',参数对象);
export default {
    // 登录
    login:(data) => Network.post('api/user/login',data),
    // 登录
    mobileLogin:(data) => Network.post('api/user/mobileLogin',data),
    // mac验证mac
    GetUserAuth:(data) => Network.get('api/user/GetUserAuth',data),
    // 获取字段
    GetTableSet:(data) => Network.get('api/Sys_Table_Set/GetTableSet',data),
    // 拖动列宽
    SaveTableSetWidth:(data) => Network.post('api/Sys_Table_Set/SaveTableSetWidth',data),
    // 保存字段
    SaveTableSet:(data) => Network.post('api/Sys_Table_Set/SaveTableSet',data),
    // 权限导航
    getTreeMenu:(data) => Network.get('api/menu/getTreeMenu',data),

    // 计价单位查询
    GetUnitList:(data) => Network.get('api/Sys_Purveyor_Price/GetUnitList',data),

    // 获取省市区
    getDistrictById:(data) => Network.get('api/District/GetDistrict',data),
    // 上传供应商图片
    UploadPurveyor:(data) => Network.post('api/Sys_Purveyor/Upload',data),
    // 供应商管理
    getPurveyor:(data) => Network.post('api/Sys_Purveyor/getPageData',data),
    // 交期信息
    getPurveyorJQ:(data) => Network.post('api/Sys_Purchase_Delivery/GetPageData',data),
    // 下拉档案
    GetVueDictionary:(data) => Network.post('api/Sys_Dictionary/GetVueDictionary',data),
    // 附件管理
    getFileList:(data) => Network.post('api/Sys_Purveyor_File/getPageData',data),
    addFileList:(data) => Network.post('api/Sys_Purveyor_File/Add',data),
    PurveyorDownFile:(data) => Network.post('api/Sys_Purveyor_File/DownFile',data),
    Purveyor_File_Log:(data) => Network.post('api/Sys_Purveyor_File_Log/getPageData',data),
    UploadFile:(data) => Network.post('api/Sys_Purveyor_File/UploadFile',data),
    DelUploadFile:(data) => Network.post('api/Sys_Purveyor_File/Del',data),

    editPurveyor:(data) => Network.post('api/Sys_Purveyor/Update',data),
    AddPurveyor:(data) => Network.post('api/Sys_Purveyor/Add',data),
    delPurveyor:(data) => Network.post('api/Sys_Purveyor/del',data),

    // 获取供应商
    GetPrdtPurveyorList:(data) => Network.get('api/Purchase/Prdt/GetPurveyorList',data),
    // 批量更新供应商 任务栏
    PrdtBatchUpdatePurveyor:(data) => Network.post('api/Purchase/Prdt/BatchUpdatePurveyor',data),
    // 批量更新供应商 购物车
    BatchUpdatePurveyor:(data) => Network.post('api/purchase/BatchUpdatePurveyor',data),

    // 供应商价目表
    getPurveyorInfo:(data) => Network.post('api/Sys_Purveyor_Info/getPageData',data),
    // 新增供应商价目表
    AddPurveyorInfo:(data) => Network.post('api/Sys_Purveyor_Info/Add',data),
    // 编辑供应商价目表
    updatePurveyorInfo:(data) => Network.post('api/Sys_Purveyor_Info/update',data),
    // 删除供应商价目表
    delPurveyorInfo:(data) => Network.post('api/Sys_Purveyor_Info/del',data),
    // 统一调价
    BatchUpdateDiscount:(data) => Network.post('api/Sys_Purveyor_Price/BatchUpdateDiscount',data),

    // 供应商价目表修改历史
    getPurveyorLogInfo:(data) => Network.post('api/Sys_Purveyor_Log_Info/GetPageData',data),
    // 供应商价目表修改历史详细
    getPurveyorPriceLog:(data) => Network.post('api/Sys_Purveyor_Price_Log/GetPageData',data),

    // 供应商价目表维护
    getPurveyorPrice:(data) => Network.post('api/Sys_Purveyor_Price/getPageData',data),
    // 供应商价目表维护 导入
    ImportPurveyorPrice:(data) => Network.post('api/Sys_Purveyor_Price/Import',data),
    ExportPurveyorPrice:(data) => Network.post('api/Sys_Purveyor_Price/Export',data),
    DownLoad:(data) => Network.get('api/Sys_Purveyor_Price/DownLoad',data),
    //根据商品编码获取商品信息
    GetPrdtListPurveyorPrice:(data) => Network.post('api/Sys_Purveyor_Price/GetPrdtList ',data),
    // 商品分类档案
    GetItemCategoryList:(data) => Network.get('api/Sys_Purveyor_Price/GetItemCategoryList',data),
    //保存价目表 
    SavePurveyorPrice:(data) => Network.post('api/Sys_Purveyor_Price/Save ',data),
    //新增 保存价目表 
    AddSave:(data) => Network.post('api/Sys_Purveyor_Price/AddSave ',data),
    //删除价目表 
    DelPurveyorPrice:(data) => Network.post('api/Sys_Purveyor_Price/Del ',data),
    //计价单位 
    getPacking:(data) => Network.post('api/Sys_Packing/getPageData ',data),
    //税率 
    getTaxRate:(data) => Network.post('api/Sys_Tax_Rate/getPageData ',data),



    // 供应商类别
    getPurveyorCategory:(data) => Network.post('api/Sys_Purveyor_Category/getPageData',data),
    // 新增供应商类别
    addPurveyorCategory:(data) => Network.post('api/Sys_Purveyor_Category/Add',data),
    // 删除供应商类别
    delPurveyorCategory:(data) => Network.post('api/Sys_Purveyor_Category/del',data),
    // 编辑供应商类别
    updatePurveyorCategory:(data) => Network.post('api/Sys_Purveyor_Category/update',data),

    // 暂停合作
    getSuspend:(data) => Network.post('api/Sys_Suspend/getPageData',data),
    // 新增暂停合作
    addSuspend:(data) => Network.post('api/Sys_Suspend/Add',data),
    // 删除暂停合作
    delSuspend:(data) => Network.post('api/Sys_Suspend/del',data),
    // 编辑暂停合作
    updateSuspend:(data) => Network.post('api/Sys_Suspend/update',data),

    // 检验级别
    getInspectionLevel:(data) => Network.post('api/Sys_Inspection_Level/getPageData',data),
    // 新增检验级别
    addInspectionLevel:(data) => Network.post('api/Sys_Inspection_Level/Add',data),
    // 删除检验级别
    delInspectionLevel:(data) => Network.post('api/Sys_Inspection_Level/del',data),
    updateInspectionLevel:(data) => Network.post('api/Sys_Inspection_Level/update',data),

    // 税率档案
    getTaxRate:(data) => Network.post('api/Sys_Tax_Rate/getPageData',data),
    // 新增税率档案
    addTaxRate:(data) => Network.post('api/Sys_Tax_Rate/Add',data),
    // 删除税率档案
    delTaxRate:(data) => Network.post('api/Sys_Tax_Rate/del',data),
    updateTaxRate:(data) => Network.post('api/Sys_Tax_Rate/update',data),

    // 签约方式
    getSigningMethod:(data) => Network.post('api/Sys_Signing_Method/getPageData',data),
    // 新增签约方式
    addSigningMethod:(data) => Network.post('api/Sys_Signing_Method/Add',data),
    // 删除签约方式
    delSigningMethod:(data) => Network.post('api/Sys_Signing_Method/del',data),
    updateSigningMethod:(data) => Network.post('api/Sys_Signing_Method/update',data),

    // 仓库列表
    GetStockList:(data) => Network.get('api/purchase/GetStockList',data),
    // 获取价目表信息 产品列表
    GetPrdtListpurchase:(data) => Network.post('api/Sale/GetPrdtList',data),
    // 新增购物车
    addCart:(data) => Network.post('api/Sale/AddCart',data),
    // 购物车数据查询
    getCartPrdtList:(data) => Network.get('api/Sale/GetCartPrdtList',data),
    // 修改购物车数量
    UpdateCartQty:(data) => Network.post('api/Sale/UpdateCartQty',data),
    // 生成报价单
    SubmitSaleQuotation:(data) => Network.post('api/Sale/Order/Submit',data),
    // 修改购物车选中状态
    UpdateCartCheck:(data) => Network.post('api/Sale/UpdateCartCheck',data),
    // 删除购物车数据
    DeleteCart:(data) => Network.post('api/Sale/DeleteCart',data),
    // 获取供应商
    GetPurveyorList:(data) => Network.get('api/purchase/GetPurveyorList',data),
    // 获取其他供应商价目表
    GetPurveyorPrdtList:(data) => Network.get('api/purchase/GetPurveyorPrdtList',data),
    // 更换供应商
    UpdateCartPurveyor:(data) => Network.post('api/purchase/UpdateCartPurveyor',data),
    // 初始化供应商档案
    InitPurveyor:(data) => Network.get('api/Sys_Purveyor/InitPurveyor',data),
    //批量加入购物车
    BachAddCart:(data) => Network.post('api/purchase/BachAddCart',data),
    // 获取购物车产品个数
    getCartNum:(data) => Network.get('api/Sale/GetCartNum',data),

    // 报价单-销售报价单-列表
    GetSaleQuotationList:(data) => Network.get('api/Sale/Order/GetSaleQuotationList',data),
	// 报价单-销售报价单-导出
	ExportOrder:(data) => Network.get('api/Sale/Order/ExportOrder',data),
	// 历史报价单-查询条件配置(按用户保存)
	GetSaleQuotationFieldConfig:() => Network.get('api/Sale/Order/GetSaleQuotationFieldConfig'),
	SaveSaleQuotationFieldConfig:(data) => Network.post('api/Sale/Order/SaveSaleQuotationFieldConfig',data),
	// 取消订单(已回传万里牛的先关闭万里牛)
	CancelSaleQuotation:(data) => Network.post('api/Sale/Order/CancelSaleQuotation',data),
	// 收款管理-确认收款/确认开票(Type:1=收款 2=开票 3=无需开票)
	ConfirmQuotationStatus:(data) => Network.post('api/Sale/Order/ConfirmQuotationStatus',data),
	// 收款管理-取分支机构收款账号
	GetStypeAccount:(data) => Network.get('api/Sale/Order/GetStypeAccount',data),
	// 万里牛备注档案(独立表 Sys_WlnRemark)-收款管理确认开票下拉
	GetWlnRemarkOptions:() => Network.get('api/Sys_WlnRemark/GetWlnRemarkOptions'),
    // 报价单-销售报价单-详情
    GetSaleQuotationInfo:(data) => Network.get('api/Sale/Order/GetSaleQuotationInfo',data),
    // 报价单-销售报价单-保存草稿
    SaveSaleQuotation:(data) => Network.post('api/Sale/Order/SaveSaleQuotation',data),
    // 快速报价单-提交报价单
    SubmitQuotation:(data) => Network.post('api/Sale/Order/SubmitQuotation',data),
    // 报价单-销售报价单-提交报价单
    SubmitSaleQuotationTj:(data) => Network.post('api/Sale/Order/SubmitSaleQuotation',data),
    // 报价单-销售报价单-成交&不成交
    SureSaleQuotation:(data) => Network.post('api/Sale/Order/SureSaleQuotation',data),
    // 报价单-销售报价单-同步万里牛
    AsyncWlnQuotation:(data) => Network.post('api/Sale/Order/AsyncOrderNo',data),
    // 报价单-销售报价单-单笔同步万里牛订单状态(兜底)
    SyncWlnStatusSingle:(data) => Network.post('api/Sale/Order/SyncWlnStatusSingle',data),
    // 报价单-销售报价单-删除
    DeleteSaleQuotationInfo:(data) => Network.post('api/Sale/Order/DeleteSaleQuotationInfo',data),
    // 报价单-销售报价单-下载
    DownloadSaleQuotationInfo:(data) => Network.get('api/Sale/Order/DownloadSaleQuotationInfoNew',data),
    // DownloadSaleQuotationInfo:(data) => Network.get('api/Sale/Order/DownloadSaleQuotationInfo',data),
    // 报价单-销售报价单-下载合同
    DownloadSaleQuotationInfoWord:(data) => Network.get('api/Sale/Order/DownloadSaleQuotationInfoWord',data),
    // 快速报价单-根据商品编码查询
    GetSalePrdtListByCode:(data) => Network.get('api/Sale/Prdt/GetSalePrdtListByCode',data),
    // 快速报价单-根据订单编号查询
    GetSalePrdtListByOrderNo:(data) => Network.get('api/Sale/Prdt/GetSalePrdtListByOrderNo',data),
    // 快速报价单-更换成本来源查询
    GetSalePrdtPriceList:(data) => Network.get('api/Sale/Prdt/GetSalePrdtPriceList',data),
    // 弹框 多选 获取商品信息
    GetPageDataForEsDialog:(data) => Network.post('api/Sys_Prdt/GetPageDataForEsDialog',data),
    // 弹框 树形
    getTreeData:(data) => Network.get('api/SysPrdtController/GetItemCategoryList',data),
    // 弹框 筛选条件
    GetPrdtBaseInfoForPop:(data) => Network.post('api/Sys_Prdt/GetPrdtBaseInfo',data),
    // 地址
    GetDistrictTree:(data) => Network.get('api/Sys_OrderController/GetDistrict',data),
    // 客户
    GetBuyerList:(data) => Network.get('api/Sale/GetBuyerList',data),
    // 获取配货方式/物流方式
    GetLogisticsOrDeliveryList:(data) => Network.get('api/Sale/Order/GetLogisticsOrDeliveryList',data),
    // 获取运费
    GetFreightAmt:(data) => Network.get('api/Sale/Order/GetFreightAmt',data),
    // 上传报价单
    downLoadImgSale:(data) => Network.post('api/Sale/Order/UploadImg',data),


    // 商品分类
    GetCategory:(data) => Network.get('api/Purchase/Prdt/GetCategory',data),
    // 商品分类 导航进入查询
    GetCategoryData:(data) => Network.get('api/Purchase/Prdt/GetCategoryData',data),
    // 产品属性--导航进入查询
    GetBaseInfoByCategory:(data) => Network.get('api/Sale/Prdt/GetBaseInfoByCategory',data),
    // 商品列表----导航进入查询
    GetPrdtByCategory:(data) => Network.get('api/Sale/Prdt/GetPrdtByCategory',data),
    // 产品属性--日常补货页面
    GetPrdtBaseInfo:(data) => Network.get('api/Purchase/Prdt/GetPrdtBaseInfo',data),
    // 商品列表----日常补货页面
    GetPrdtList:(data) => Network.get('api/Purchase/Prdt/GetPrdtList',data),
    //导出
    Export:(data) => Network.post('api/Purchase/Prdt/Export',data),
    // 历史采购记录查询----日常补货页面
    GetBuyOrderPrdtList:(data) => Network.get('api/purchase/GetBuyOrderPrdtList',data),

    // 产品属性---缺货补货页面
    GetPrdtBaseInfoNotQty:(data) => Network.get('api/Purchase/Prdt/GetPrdtBaseInfoNotQty',data),
    // 商品列表-----缺货补货页面
    GetPrdtNotQtyList:(data) => Network.get('api/Purchase/Prdt/GetPrdtNotQtyList',data),

    // 单个加入采购任务
    AddTask:(data) => Network.post('api/Purchase/Prdt/AddTask',data),
    // 当前页加入采购任务
    BachAddTask:(data) => Network.post('api/Purchase/Prdt/BachAddTask',data),
    // 一键加入采购任务
    BachAddTaskCondition:(data) => Network.post('api/Purchase/Prdt/BachAddTaskCondition',data),

    // 采购任务----查询
    GetTaskPrdtList:(data) => Network.get('api/Purchase/Prdt/GetTaskPrdtList',data),
    // 采购任务---- 修改数量
    UpdateTaskQty:(data) => Network.post('api/Purchase/Prdt/UpdateTaskQty',data),
    // 采购任务---- 修改选中状态
    UpdateTaskCheck:(data) => Network.post('api/Purchase/Prdt/UpdateTaskCheck',data),
    // 采购任务---- 更换供应商
    UpdateTaskPurveyor:(data) => Network.post('api/Purchase/Prdt/UpdateTaskPurveyor',data),
    // 采购任务---- 删除
    DeleteTask:(data) => Network.post('api/Purchase/Prdt/DeleteTask',data),

    // 查询结算 
    GetSettlePrdtList:(data) => Network.get('api/purchase/GetSettlePrdtList',data),
    //地址识别
    GetAddressSplit:(data) => Network.get('api/purchase/GetAddressSplit',data),
    // 提交订单
    SubmitOrder:(data) => Network.post('api/Sale/Goods/SubmitOrder',data),
    //下载Excel
    ExportError:(data) => Network.post('api/Sys_Purveyor_Price/ExportError',data),

    //生成询价单=============
    // 生成图片并保存报价单
    SaveQuotation:(data) => Network.post('api/Quotation/SaveQuotation',data),
    // 导出文件，返回日期+文件名
    exportQuotation:(data) => Network.post('api/Quotation/ExportQuotation',data),
    // 下载图片
    downLoadImg:(data) => Network.post('api/Quotation/DownLoadImg',data),
    // 下载Excel
    downLoadExcel:(data) => Network.post('api/Quotation/DownLoadExcel',data),
    // 获取用户报价单
    getQuotationList:(data) => Network.get('api/Quotation/GetQuotationList',data),
    // 获取用户报价单详情
    getQuotationDetail:(data) => Network.get('api/Quotation/GetQuotationDetail',data),

    // 个人中心左侧菜单数量
    GetMenuNum:(data) => Network.get('api/Sale/Goods/GetMenuNum',data),
    // 订单状态
    GetStatusNum:(data) => Network.get('api/Sale/Goods/GetStatusNum',data),
    // 日志
    sys_purchase_order_log:(data) => Network.post('api/sys_purchase_order_log/getPageData',data),
    // 订单列表
    getOrderList:(data) => Network.get('api/Sale/Goods/GetBuyerOrders',data),
    // 财务确认列表
    GetBuyerOrdersFinanceSure:(data) => Network.get('api/Sale/Goods/GetBuyerOrdersFinanceSure',data),
    // 财务付款列表
    GetBuyerOrdersFinancePay:(data) => Network.get('api/Sale/Goods/GetBuyerOrdersFinancePay',data),
    // 财务退款列表
    GetBuyerOrdersFinanceReturnPay:(data) => Network.get('api/Sale/Goods/GetBuyerOrdersFinanceReturnPay',data),
    // 超期订单
    GetBuyerOrdersOverdue:(data) => Network.get('api/Sale/Goods/GetBuyerOrdersOverdue',data),
    // 财务确认
    FinanceSureOrder:(data) => Network.post('api/Sale/Goods/FinanceSureOrder',data),
    // 财务撤回
    FinanceBackOrder:(data) => Network.post('api/Sale/Goods/FinanceBackOrder',data),
    // 财务付款 撤回
    FinancePayBackOrder:(data) => Network.post('api/Sale/Goods/FinancePayBackOrder',data),
    // 订单明细
    getOrdersDetails:(data) => Network.get('api/Sale/Goods/GetBuyerOrderInfo',data),
    // 复制订单 订单明细
    getOrdersDetailsCopy:(data) => Network.get('api/Sale/Goods/CopyOrder',data),
    // 订单取消
    cancelOrder:(data) => Network.post('api/Sale/Goods/CancelOrder',data),
    // 订单关闭
    closeOrder:(data) => Network.post('api/Sale/Goods/CloseOrder',data),
    // 确认订单
    sureOrder:(data) => Network.post('api/Sale/Goods/SureOrder',data),
    // 确认付款
    SureOrderPay:(data) => Network.post('api/Sale/Goods/SureOrderPay',data),
    // 确认通知
    SureOrderNotice:(data) => Network.post('api/Sale/Goods/SureOrderNotice',data),
    // 订单取消
    CancelOrder:(data) => Network.post('api/Sale/Goods/CancelOrder',data),
    // 退款取消
    ReturnPayCancelOrder:(data) => Network.post('api/Sale/Goods/ReturnPayCancelOrder',data),
    // 确认退款
    SureReturnPay:(data) => Network.post('api/Sale/Goods/SureReturnPay',data),
    // 修改仓库
    UpdateOrderStock:(data) => Network.post('api/Sale/Goods/UpdateOrderStock',data),
    // 修改外部单号
    UpdateOrderExternalNo:(data) => Network.post('api/Sale/Goods/UpdateOrderExternalNo',data),
    // 再来一单
    BuyAgain:(data) => Network.get('api/Sale/Goods/BuyAgain',data),
    // 上传凭证
    UploadPurchase:(data) => Network.post('api/Sys_Purchase_Order/Upload',data),

    // 采购任务池
    GetDataPage:(data) => Network.get('api/View_Bill_Buy_Item/GetDataPage',data),
    // 入库仓库
    getPageDataStock:(data) => Network.post('api/Sys_Stock/getPageData',data),
    // 分支机构
    getPageDataStype:(data) => Network.post('api/Sys_Stype/getPageData',data),
    // 采购任务池 查询产品
    GetBuyPrdtList:(data) => Network.post('api/purchase/GetBuyPrdtList',data),
    // 获取超时任务数据
    GetOvertimeList:(data) => Network.get('api/purchase/GetOvertimeList',data),
    // 预警/缺货记录
    GetPrdtLogList:(data) => Network.get('api/purchase/GetPrdtLogList',data),

    // 新增采购订单
    // 根据供应商和仓库获取交期
    GetEstDate:(data) => Network.get('api/Sale/Goods/GetEstDate',data),
    // 分支机构
    GetStypeList:(data) => Network.get('api/Sale/Goods/GetStypeList',data),
     // 入库仓库
     GetStockListOrder:(data) => Network.get('api/Sale/Goods/GetStockList',data),
    // 供应商档案
    GetPurveyorListOrder:(data) => Network.get('api/Sale/Goods/GetPurveyorList',data),
    // 获取商品信息
    GetPrdtListOrder:(data) => Network.post('api/Sale/Goods/GetPrdtList',data),
    // 弹框 单选 获取商品信息
    getPageDataPrdt:(data) => Network.post('api/Sys_Prdt/GetPageDataForEs',data),
    // 弹框 多选 获取商品信息
    GetPageDataForEsDialog:(data) => Network.post('api/Sys_Prdt/GetPageDataForEsDialog',data),
    // 弹框 树形
    getTreeData:(data) => Network.get('api/SysPrdtController/GetItemCategoryList',data),
    // 弹框 筛选条件
    GetPrdtBaseInfoForPop:(data) => Network.post('api/Sys_Prdt/GetPrdtBaseInfo',data),
    // 相似订单查询
    SimilarityOrder:(data) => Network.post('api/Sale/Goods/SimilarityOrder',data),
    // 保存草稿
    SaveOrder:(data) => Network.post('api/Sale/Goods/SaveOrder',data),
    // 删除
    DelPrdt:(data) => Network.post('api/Sale/Goods/DelPrdt',data),
    // 提交订单
    SubmitBuyOrder:(data) => Network.post('api/Sale/Goods/SubmitBuyOrder',data),
    // 个人中心-采购订单 保存外部单号，外部单号备注，订单备注，议价修改
    UpdateOrder:(data) => Network.post('api/Sale/Goods/UpdateOrder',data),
    // 复制订单
    CopyOrder:(data) => Network.get('api/Sale/Goods/CopyOrder',data),

    // 下载中心
    GetListDownload:(data) => Network.get('api/Sys_Download/GetList',data),
    // 头部下载中心
    GetDayList:(data) => Network.get('api/Sys_Download/GetDayList',data),
    // 删除
    DelDownload:(data) => Network.post('api/Sys_Download/Del',data),
    








    // 注册
    register:(data) => Network.post('api/user/Register',data),
    //  获取注册页面配置
    GetRegisterPageConfig:(data) => Network.get('api/configCg/GetRegisterPageConfig',data),
    //验证公司、手机号
    checkphonecompany:(data) => Network.get('api/user/CheckPhoneOrCompany',data),
    // 找回密码
    modify:(data) => Network.post('api/user/modifyPwd',data),
    // 获取图文验证码
    getVierificationCode:() => Network.get('api/user/GetVierificationCode'),
    // 发送短信
    sendMobileCode:(data) => Network.post('api/user/SendRegisterCode',data),
    // 忘记密码
    forgetPwd:(data) => Network.post('api/user/ForgetPwd',data),
    // 验证短信
    ForgetPwdValidCode:(data) => Network.post('api/user/ForgetPwdValidCode',data),
    // 修改密码
    updatePwd:(data) => Network.post('api/user/UpdatePwd',data),
    // 获取用户信息
    getCurrentUserInfo:(data) => Network.post('api/user/GetCurrentUserInfo',data),
    // 系统配置
    config:() => Network.get('api/configCg/GetSysConfig'),
    // 获取注册协议
    getSysConfigToRegister:() => Network.get('api/user/GetSysConfigToRegister'),
    // 轮播图
    chartlist:(data) => Network.get('api/SysContentConfig/GetSysCarouselChartList',data),
    // 新闻公告
    newslist:(data) => Network.get('api/SysContentConfig/GetNewsList',data),
    // 底部导航信息
    navigationlist:(data) => Network.get('api/SysContentConfig/GetBottomNavigationsList',data),
    // 头部导航分类
    classify:() => Network.get('api/MallSlassification/Sale/GetMallSlassificationList'),
    // 分类下拉
    SearchMallSlassificationSelect:(data) => Network.get('api/MallSlassification/SearchMallSlassificationSelect',data),

    
    // 搜索 产品条件查询
    getStandardCondition:(data) => Network.get('api/Standard/GetPrdtBaseInfo',data),
    // 搜索 产品列表查询
    getStandardProduct:(data) => Network.get('api/Standard/GetPrdtList',data),
    // 保存样式
    SavePrdtStyle:(data) => Network.post('api/configCg/SavePrdtStyle',data),
    
    // 产品详情
    getPrdtInfo:(data) => Network.get('api/Prdt/GetPrdtInfo',data),
    // 热词搜索
    getSearchRecordList:(data) => Network.get('api/Prdt/GetSearchRecordList',data),
    // 加入购物车
    // addCart:(data) => Network.post('api/Cart/AddCart',data),
    // 修改购物车数量
    // updateCartQty:(data) => Network.post('api/Cart/UpdateCartQty',data),
    // 修改购物车选中项
    // updateCartCheck:(data) => Network.post('api/Cart/UpdateCartCheck',data),
    // 修改购物车选中项
    delCart:(data) => Network.post('api/Cart/DelCart',data),
    // 批量修改购物车选中项
    DelCartBatch:(data) => Network.post('api/Cart/DelCartBatch',data),
    // 重新计算运费 
    CalcFreightAmt:(data) => Network.post('api/Cart/CalcFreightAmt',data),


    // 添加到货通知
    addCollection:(data) => Network.post('api/Collections/AddCollection',data),
    // 删除到货通知
    delCollection:(data) => Network.post('api/Collections/DelCollection',data),
    // 修改到货通知
    updateCollection:(data) => Network.post('api/Collections/UpdateCollection',data),
    // 添加到货通知
    getCollectionList:(data) => Network.get('api/Collections/GetPrdtList',data),
    // 获取服务器时间
    getCurrentDateTime:(data) => Network.get('api/purchase/GetCurrentDateTime',data),
    // 获取收货地址数据
    getUserAddressList:(data) => Network.get('api/BuyerAddress/GetUserAddress',data),
    // 获取收货地址数据 带分页
    getUserAddressListPage:(data) => Network.get('api/BuyerAddress/GetUserAddressPage',data),
    // 获取收货地址数据
    getUserAddressInfo:(data) => Network.get('api/BuyerAddress/GetUserAddressInfo',data),
    // 新增收货地址数据
    addBuyerAddress:(data) => Network.post('api/BuyerAddress/AddBuyerAddress',data),
    // 修改收货地址数据
    uptBuyerAddress:(data) => Network.post('api/BuyerAddress/UptBuyerAddress',data),
    // 删除收货地址数据
    delBuyerAddress:(data) => Network.post('api/BuyerAddress/DelBuyerAddress',data),
    // 设置默认收货地址
    setBuyerAddressDefault:(data) => Network.post('api/BuyerAddress/UptBuyerAddressDefault',data),
   
    // 退货列表
    getReturnOrderList:(data) => Network.get('api/Order/GetBuyerReturnOrders',data),
    // 退货详情
    getReturnOrderDetail:(data) => Network.get('api/Order/GetReturnOrderDetail',data),
    // 申请退货
    applyReturnOrder:(data) => Network.post('api/Order/ApplyReturnOrder',data),
    // 获取退货原因
    getReturnReasonList:(data) => Network.get('api/Order/GetReturnReasonList',data),
    // 获取站内消息
    getMessageList:(data) => Network.get('api/Message/GetMessageList',data),
    // 设置为已读
    setRead:(data) => Network.post('api/Message/UpdateIsRead',data),
    // 删除站内消息
    delMessage:(data) => Network.post('api/Message/DelMessage',data),
    // 对账列表
    getAccountList:(data) => Network.get('api/Account/GetAccountList',data),
    // 对账明细
    getAccountInfo:(data) => Network.get('api/Account/GetAccountInfo',data),
    // 获取开票信息
    getInvoInfo:() => Network.get('api/user/GetInvoInfo'),
    // 更新开票信息
    updateInvo:(data) => Network.post('api/user/UpdateInvo',data),
    // 更新收票信息
    updateReceipt:(data) => Network.post('api/user/UpdateReceipt',data),
    // 刷新taoken
    replaceToken:(data) => Network.post('api/user/replaceToken',data),
    //判断背景色是否变更
    changeColor:(data) => Network.get('api/configCg/IfColorChange',data),
    // 获取广告位
    GetAdvertisement:(data) => Network.get('api/SysContentConfig/GetAdvertisement',data),
    
    //获取支付方式
    GetPaymentList:(data) => Network.post('api/Pay/GetPayInfo',data),
    //提交支付
    PayOrder:(data) => Network.post('api/Pay/ToOrder',data),
    //获取支付状态
    GetOrderPayStatus:(data) => Network.get('api/Pay/GetOrderPayStatus',data),
    
    //多个订单支付
    ToOrderList:(data) => Network.post('api/Pay/ToOrderList',data),
    //订单通知接口
    NotifyOrder:(data) => Network.get('api/Pay/NotifyOrder',data),

    //对账单支付
    ToPyaAccountInfo:(data) => Network.post('api/Pay/ToPyaAccountInfo',data),
    //对账单支付状态查询
    NotifyAccountInfo:(data) => Network.get('api/Pay/NotifyAccountInfo',data),
    
    
    //非标定制品相关接口
    AddCustomized:(data) => Network.post('api/customized/AddCustomized',data),
    //上传文件
    UploadForApi:(data) => Network.post('api/customized/UploadForApi',data),
    //获取非标订制品
    GetCustomizedList:(data) => Network.get('api/customized/GetCustomizedList',data),
    //获取非标订制品 详情
    GetCustomizedDetail:(data) => Network.get('api/customized/GetCustomizedDetail',data),

    //保存产品自定义编码
    SavePrdtCustom:(data) => Network.post('api/Prdt/Custom/SavePrdtCustom',data),
    //自定义编码查询
    GetPrdtCustomList:(data) => Network.get('api/Prdt/Custom/GetPrdtCustomList',data),
    //删除产品自定义编码
    DelPrdtCustom:(data) => Network.post('api/Prdt/Custom/DelPrdtCustom',data),
    //下载导入Excel模板
    DownLoadPrdtCustom:(data) => Network.get('api/Prdt/Custom/DownLoadPrdtCustom',data),
    //导入表数据Excel文件夹
    ImportPrdtCustom:(data) => Network.post('api/Prdt/Custom/ImportPrdtCustom',data),
    //导出文件，返回日期+文件名
    ExportPrdtCustom:(data) => Network.post('api/Prdt/Custom/ExportPrdtCustom',data),

    //导出我的物料，用来添加购物车
    ExportMyPrdtCustom:(data) => Network.post('api/Prdt/Custom/ExportMyPrdtCustom',data),
    //导入表数据Excel文件夹
    ImportCartPrdt:(data) => Network.post('api/Prdt/Custom/ImportCartPrdt',data),
    //自定义编码购物车， 快速下单导入和查询后调用这个接口  返回所有自定义编码购物车的数据
    GetCartPrdtCustomList:(data) => Network.get('api/Prdt/Custom/GetCartPrdtCustomList',data),
    
    // 新增自定义编码到购物车，数量累加
    GetAddCartPrdtCustomList:(data) => Network.get('api/Prdt/Custom/GetAddCartPrdtCustomList',data),
    // 删除产品自定义编码
    DelCartPrdtCustom:(data) => Network.post('api/Prdt/Custom/DelCartPrdtCustom',data),
    // 编辑自定义编码购物车数量
    UpdateCartPrdtCustom:(data) => Network.post('api/Prdt/Custom/UpdateCartPrdtCustom',data),

    // 充值获取支付方式
    GetRechargePayInfo:(data) => Network.post('api/Pay/GetRechargePayInfo',data),
    // 充值
    ToRecharge:(data) => Network.post('api/Pay/ToRecharge',data),
    // 获取转入记录
    GetSurplusCheckPage:(data) => Network.get('api/user/GetSurplusCheckPage',data),
    // 充值-查询支付状态
    GetRechargePayStatus:(data) => Network.get('api/Pay/GetRechargePayStatus',data),
    // 设置支付密码
    SetPayPwd:(data) => Network.post('api/user/SetPayPwd',data),
    // 获取余额流水
    GetSurplusPage:(data) => Network.get('api/user/GetSurplusPage',data),
    // 校验支付密码是否正确
    CheckPayPwd:(data) => Network.post('api/user/CheckPayPwd',data),
    // 余额提现
    ToWithdrawal:(data) => Network.post('api/Pay/ToWithdrawal',data),
    
    // 校验支付密码是否正确
    CheckPayPwd:(data) => Network.post('api/user/CheckPayPwd',data),
    // 提现申请记录
    GetWithdrawalCheckPage:(data) => Network.get('api/user/GetWithdrawalCheckPage',data),

    // 货拉拉
    GetAccoutToken:(data) => Network.get('api/HuoLaLa/GetAccoutToken',data),
    GetUCityInfo:(data) => Network.get('api/HuoLaLa/GetUCityInfo',data),
    GetUOrderCalculate:(data) => Network.post('api/HuoLaLa/GetUOrderCalculate',data),
    GetUOrderRequest:(data) => Network.get('api/HuoLaLa/GetUOrderRequest',data),
    GetOrderCashier:(data) => Network.get('api/HuoLaLa/GetOrderCashier',data),
    GetOrderPayStatusForHll:(data) => Network.get('api/HuoLaLa/GetOrderPayStatus',data),

    // 埋点
    AddBuyerAct:(data) => Network.post('api/user/AddBuyerAct',data),
    // 自定义商品导出
    ExportPrdtList:(data) => Network.post('api/Prdt/ExportPrdtList',data),
    // 自定义商品导入
    ImportPrdtCustom:(data) => Network.post('api/Prdt/ImportPrdtCustom',data),

    // 投诉反馈=========
    //获取下拉框的值
    GetComplaintEnum:(data) => Network.get('api/Complaint/GetComplaintEnum',data),
    //分页获取数据
    GetComplaintPage:(data) => Network.get('api/Complaint/GetComplaintPage',data),
    //分页获取数据 详情
    GetComplaintInfo:(data) => Network.get('api/Complaint/GetComplaintInfo',data),
    //新增投诉反馈
    AddComplaint:(data) => Network.post('api/Complaint/AddComplaint',data),
    //删除投诉反馈
    DelComplaint:(data) => Network.post('api/Complaint/DelComplaint',data),


    //保存头像
    SetHeadImageUrl:(data) => Network.post('api/user/SetHeadImageUrl',data),

    //首页广告模块 SourceType（1电脑端,2微信端,3小程序,4安卓端,5苹果端,6代理端）
    GetAdverModule:(data) => Network.get('api/SysContentConfig/GetAdverModule',data),

    //获取首页配置
    GetHomeTemplate:(data) => Network.get('api/purchase/GetHomeTemplate',data),
	
	downLoadHistoryExcel:(data) => Network.post('api/Quotation/DownLoadExcel',data),
    //判断新老客户
	CheckContactIsOld:(data) => Network.get('api/Sale/Order/CheckContactIsOld',data),
    
	GetAddressSplitCg:(data) => Network.get('api/configCg/GetAddressSplit',data),
    // 打印模板列表
    GetContractPrintData:(data) => Network.get('api/Sale/Order/GetContractPrintData',data),
    // 打印excel/图片
    GetSaleQuotationData:(data) => Network.get('api/Sale/Order/GetSaleQuotationData',data),
}